import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';

interface ContainerProps extends PropsWithChildren {
  className?: string;
  innerClassName?: string;
}

const Container: FunctionComponent<ContainerProps> = ({
  className,
  innerClassName,
  children,
}) => {
  return (
    <div className={className}>
      <div
        className={classNames(
          'max-w-[1180px] w-full mx-auto xl:px-xl md:px-md px-base',
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Container;
